<div>

  <kendo-grid [data]="view | async"
              [loading]="service.loading"
              [pageSize]="state.take"
              [skip]="state.skip"
              [sort]="state.sort"
              [pageable]="{
                  pageSizes:[5, 10, 15, 20, 50]
                }"
              (edit)="onEditRoleTemplate($event)"
              (add)="onAddRoleTemplate()"
              (remove)="onDeleteRoleTemplate($event)"
              (dataStateChange)="onStateChange($event)"
              [height]="heightGrid">

    <ng-template kendoGridToolbarTemplate>
      <button kendoGridAddCommand type="button" *ngIf="showAdd">
        <span class="fas fa-plus" title="Add New Template"></span>
      </button>
    </ng-template>

    <kendo-grid-column [hidden]="true" field="id" title="Id"></kendo-grid-column>

    <kendo-grid-column field="isActive" title="Active" editor="boolean" [width]="80" class="isg-kgrid-cell-center">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [appNullableBooleanClass]="dataItem.isActive"></span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="name" title="Name" [width]="250"></kendo-grid-column>

    <kendo-grid-column field="roleTypeName" title="Role Type" [width]="120"></kendo-grid-column>

    <kendo-grid-column [hidden]="true" field="applicationId" title="applicationId"></kendo-grid-column>


    <kendo-grid-column field="intDescription" title="Description">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="isg-kgrid-cell-vertscroll-m">
          {{ dataItem.intDescription }}
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="lastModifiedByName" title="last Modified" [width]="150" media="(min-width: 1720px)">
      <ng-template kendoGridHeaderTemplate>
        Modified <br /> Last By
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="lastModifiedOn" title="Last Modified On" editor="date" [width]="120" media="(min-width: 1600px)">
      <ng-template kendoGridHeaderTemplate>
        Last <br />Modified On
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{dataItem.lastModifiedOn | datePreference:false}}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-command-column title="" [width]="100">
      <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
        <button kendoGridEditCommand [primary]="true" title="Edit Template">
          <span class="far fa-pencil"></span>
        </button>
        <button kendoGridRemoveCommand title="Delete Template" *ngIf="dataItem.roleType != 'INT'">
          <span class="far fa-trash"></span>
        </button>
      </ng-template>
    </kendo-grid-command-column>

    <kendo-grid-messages [pagerItemsPerPage]="'Templates per request'" [pagerItems]="'Templates'"
                         [pagerOf]="'of'" [pagerPage]="'Page'">
    </kendo-grid-messages>

  </kendo-grid>

  <app-role-template-editor [editDataItem]="editDataItem"
                            [isNew]="isNew"
                            (save)="onSaveRoleTemplate($event)"
                            (cancel)="onCancelRoleTemplate()">
  </app-role-template-editor>

</div>
